'use strict';

(function () {
  var form = document.querySelector('.form.form--move-progress');
  var pageTitle = document.querySelector('.page-title');

  if (!form || !pageTitle) {
    return;
  }

  var formSteps = form.querySelector('.gf_progressbar_wrapper');

  pageTitle.appendChild(formSteps);
  pageTitle.classList.add('page-title--show-progress');
})();